module.exports = __webpack_public_path__ + "img/broadcast-scene-2.7b9a69f4.png";